import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, setSessionToken} from 'Skelet/src/modules/fetch.action.js'

class AdminAccounts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0};
  }

  componentWillMount() {
    if(!this.props.is_admin) {
      this.props.setSessionToken(null);
    }
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "hnnmw-account-index", "GET", config.api_url+"/hnnmw-account-index?t="+this.props.session_token, undefined, {"PM-List-Page":this.state.page});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!nextProps.is_admin) {
      this.props.setSessionToken(null);
    }
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "hnnmw-account-index", "GET", config.api_url+"/hnnmw-account-index?t="+nextProps.session_token);
    }
  }

  render() {
    let cards = "", end_of_list_text = "", page_cards = this.props.apiData["hnnmw-account-index"];
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        return <div key={i}>
          <small style={{marginTop:"2em", marginBottom:"10px", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>id {item.id} | status {item.status}</small>
          <div className="card polls card-layout">
            <div className="card-layout-div85">{item.firstname+" "+item.lastname}</div>
            <div className="card-layout-div15 btn-detail">{item.email}</div>
          </div>
        </div>;
      });
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Loading..";
    } else if((page_cards !== undefined && !page_cards.isFetching && page_cards.limitReached)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = ""; // End of results.
      } else {
        end_of_list_text = "No polls.";
      }
    }

    return (
      <div className="container content">
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Admin</strong></div>
          <div className="card-layout-div50 index-actions">
          </div>
        </div>
        {cards}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null, account_data = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    account_data = state.apiData["login"]["data"];
  }
  return {
    account_data: account_data,
    is_admin: (account_data.email === "hi@peter.plus") ? true : false,
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    setSessionToken,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAccounts)



// WEBPACK FOOTER //
// ./src/containers/AdminAccounts.js